<template>
  <SvgBase iconName="File" width="22" height="22" fill="none">
    <g clip-path="url(#clip0_8293_9687)">
      <path
        d="M3.87305 15.6349V4.391C3.87305 3.98686 4.03491 3.59927 4.32304 3.3135C4.61117 3.02773 5.00195 2.86719 5.40942 2.86719H18.585C18.993 2.86718 19.3844 3.02754 19.6734 3.31315C19.9625 3.59875 20.1256 3.98633 20.1272 4.391V19.6118C20.1256 20.0164 19.9625 20.404 19.6734 20.6896C19.3844 20.9752 18.993 21.1356 18.585 21.1356H9.40166C9.13952 21.1349 8.88835 21.0311 8.70331 20.847L4.16403 16.3275C3.97834 16.144 3.87369 15.8949 3.87305 15.6349V15.6349Z"
        stroke="#F2F2F2"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M3.83228 15.707H8.67418C8.8512 15.7085 9.02055 15.779 9.14573 15.9031C9.27091 16.0273 9.34191 16.1952 9.34343 16.3708V21.1558"
        stroke="#F2F2F2"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path d="M6.91064 7.60547H17.0775" stroke="#F2F2F2" stroke-width="2" stroke-miterlimit="10" />
      <path d="M6.91064 11.9844H17.0775" stroke="#F2F2F2" stroke-width="2" stroke-miterlimit="10" />
    </g>
    <defs>
      <clipPath id="clip0_8293_9687">
        <rect width="18" height="20" :fill="color" transform="translate(3 2)" />
      </clipPath>
    </defs>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconFile extends Vue {}
</script>
